import type { ClientProjectActivity } from '@packages/types';

/**
 * Why this activity cannot be edited, or null when it can be.
 *
 * Any member who can see an activity may edit it, so the only reason left is
 * that it sits on an invoice and its value is fixed (the service rejects every
 * update to an INVOICED row, not just the type/unit fields).
 *
 * The string is banner / tooltip copy, so a null reason means editable.
 *
 * Shared by the wizard's read-only banner and the linked-activity card's Edit
 * gate so the two surfaces cannot disagree about what is editable.
 */
export function activityEditBlockedReason(
  activity: Pick<ClientProjectActivity, 'status'>,
): string | null {
  return activity.status === 'INVOICED'
    ? 'This activity has been invoiced and cannot be edited.'
    : null;
}

/**
 * Whether the file note can be edited. True when the entry is editable, and
 * also when the only thing locking it is that it has been invoiced: the note
 * is internal and never billed, so the invoice does not lock it. Any other
 * reason that blocks editing keeps the note read-only too.
 */
export function activityNoteEditable(
  activity: Pick<ClientProjectActivity, 'status'>,
): boolean {
  return activityEditBlockedReason(activity) === null || activity.status === 'INVOICED';
}
